import { render, staticRenderFns } from "./articulos.vue?vue&type=template&id=7e797919&"
import script from "./articulos.vue?vue&type=script&lang=ts&"
export * from "./articulos.vue?vue&type=script&lang=ts&"
import style0 from "./articulos.vue?vue&type=style&index=0&id=7e797919&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports